<template>
  <div id="app">
    <cookie-law theme="bb">
  <div class='cookie-bg' slot-scope="props">
    <p>
      {{p['cookie-text']}}
    </p>
    <div class="skew cc-button button-accept" @click="props.accept"><span>{{p['cookie-button-accept']}}</span></div>
    <div class="skew cc-button button-ignore" @click="props.close"><span>{{p['cookie-button-ignore']}}</span></div>
  </div>

</cookie-law>
    <Navigation :slogan='p.slogan' :isCurrentUser='isCurrentUser()' :lang='lang' :navigation='navigation' v-on:langChange='changeLang()' v-on:logout='logout()' ></Navigation>
<!--     <div v-if='isCurrentUser()' @click='logout' class="logout-button"></div> -->

    <router-view :footer='footer' :p='p' :langsufix='langsufix' :sidenav='sidenav'/>
    <Footerel :lang='lang' :footer='footer'>
    </Footerel>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import Navigation from '@/components/Navigation.vue'
  import Footerel from '@/components/Footerel.vue'
  import CookieLaw from 'vue-cookie-law'
  import db from '@/components/firebaseinit'
  const users = db.collection('users')
  export default {
    name: 'app',
    components: {
      CookieLaw,
      Navigation,
      Footerel
    },
    data() {
      return {
        navigation: [],
        sidenav: [],
        footer: [],
        lang: 'de',
        users: [],
        langsufix: 'de-de',
        p: {},
        admin: false
      }
    },
    created () {
      this.getPermissions()
      var langCookie = this.$cookie.get('lang');

      if (langCookie == 'de-de') {
        this.langsufix = langCookie
        this.lang = 'en'
      }
      else if (langCookie == 'en-gb') {
        console.log('set en gb');
        this.langsufix = langCookie
        this.lang = 'de'
      }
      this.getContent();

    },
    computed: {
      isAdmin() {
        return this.admin
      }
    },
    // updated: function () {
    //   this.$nextTick(function () {
    //     // console.log('on page');

    //   })
    // },
    mounted: function() {
        // From testing, without a brief timeout, it won't work.
        // setTimeout(() => this.scrollFix(this.$route.hash), 2)
    },

    firestore: {
      users: db.collection('users')
    },
    methods: {
        // scrollFix: function(hashbang)
        // {
        //   location.href = hashbang;
        // },
     isCurrentUser(){
       let userExist = firebase.auth().currentUser ? true : false
       return userExist
     },
      getPermissions() {
        console.log('getting PERSMISSIONS')
        let currentUser = firebase.auth().currentUser
        if(currentUser) {
          let user_id = currentUser.X.O
          // console.log(this.user().X.O);
          console.log(users);
          users.where("user_id", "==", user_id).get().then((query) => {
            query.forEach((doc) => {
              console.log('DOC');
              console.log(doc.data());
              if(doc.exists) {
                this.admin = doc.data().admin

              }
            })

          })
        } else {

        }
      },
      changeLang() {
        if (this.langsufix == 'de-de')
          this.$cookie.set('lang','en-gb')
        else
          this.$cookie.set('lang','de-de')

        this.$router.go()
      },
      getContent () {
        console.log('GET CONTENT', this.langsufix)
        this.$prismic.client.getByUID('navigation','navigation-'+this.langsufix)
        .then((document) => {
            this.p = document.data;
            this.navigation = document.data.navigation;
            // this.sidenav = document.data.sidenav;
            // this.footer = document.data.footer;
            console.log('data',this.p);
        })
        this.$prismic.client.getByUID('footer','footer-'+this.langsufix)
        .then((document) => {
            // this.sidenav = document.data.sidenav;
            this.footer = document.data;
            console.log('data',this.footer);
        })
      },
      user() {
        return firebase.auth().currentUser
      },
      logout () {
        console.log('logout');
        firebase.auth().signOut().then(() => {
          this.$router.push('/login');
        })
      }
    }
  }
</script>

<style lang="less">
@import './less/variables.less';
ul {
  margin: 0;
}
.Cookie--bb {
  background-color: #171717;
  padding: 50px 50px;
  text-align: left;
  p {
    text-align: left;
    min-height: 50px;
    margin-bottom: 40px;
    .fm(16px);
  }
  .cc-button.button-accept {
    padding: 15px, 55px;
    width: 300px;
    text-align: center;
        border: solid;
    border-color: white;
  }
  .cc-button.button-ignore {
    padding: 15px, 55px;
    background-color: transparent;
    border: solid;
    border-color: white;
    color: white;
  }
  .cc-button {
    .fmb(14px);
    text-transform: uppercase;
    display: inline-block;
    background-color: white;
    color: black;
    padding: 15px 25px;
    margin-right: 14px;
    margin-bottom: 15px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

}

#app {
  text-align: center;
  // margin-top: 60px;
  .logo {
    width: 40%;
    position: relative;
    height: 200px;
    background-size: auto auto;
    .remove {}
  }
}

body {
  background-color: black;
  color: white;
  padding: 0px;
  margin: 0px;
}
.spacer {
  position: relative;
  width: 100%;
  min-height: 180px;
  height: 35%;
  @media (max-width: @mobile_width) {
    height: 120px;
     min-height: 0px;

  }

}

.page {
  position: relative;
    // background-color: green;
    // padding-top: 40px;
    width: 100%;
    height: 100%;
    margin: 0px 0px;
    top: 0px;
    left: 0px;
  }
    .fullscreen-bg__video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
  .logout-button {
    background-color: rgba(255,255,255,0.2);
    width: 40px;
    height: 40px;
    position: absolute;
    right: 10px;
    .br(40px);
    background-image: url('/images/close_icon.svg');
    background-size: 30% auto;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 200;
  }

  #sidenav {
    position: relative;
    left: 0px;
    // background-color: red;
    z-index: 10;
    text-align: left;
    width: 100%;
  }
  .page-content.popup {

    .close-button {
      width: 20px;
      height: 20px;
      // background-color: red;
      position: relative;
      right: 0px;
      margin-right: 20px;
      background-image: url('/images/close.svg');
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
    @media (min-width: @mobile_width) {
     width: 70%;
     position: absolute;
     left: 0px;
     margin-left: 12.5%;
     top: -20%;
    }
  }
  .page-content {
    // background-color: rgba(255,255,255,0.9);
    // padding: 15px 35px;
    // margin-bottom: 15px;
    // width: 30%;
    // min-width: 250px;
    // position: relative;
    // top: 0px;
    // left: 450px;
    .splitline {
      width: 100%;
      height: 1px;
      background-color: @c1;
      margin-bottom: 25px;
    }


    h1 {
      .fmb(31px);
      line-height: 31px;
      width: 80%;
      color: @c1;
      text-transform: uppercase;
      padding-bottom: 0px;
    }
    h2 {
     .fmb(16px);
      line-height: 21px;
      width: 70%;
      color: @c2;
      text-transform: uppercase;
      padding-bottom: 0px;

    }
    p {
      .fms(14px);
      letter-spacing: 0.5px;
      color: @c2;
      margin: 0px;
      margin-bottom: 20px;
      a {
        .fms(16px);
        color: @c2;
         text-decoration-color: @c1;

      }
    }

  @media (max-width: @mobile_width) {
    position: relative;
    left: 0px;
    top: 0px;
    width: 70%;
    min-width: 0px;
    padding: 10px 5%;
    margin-bottom: 0px;
    h1 {
       .fmb(21px);
       line-height: 21px;
    }
    p {
      .fms(12px);
      line-height: 16px;
    }

  }
    .forgot {
      clear: both;
      padding-top: 25px;
      color: @c2;
       .fms(14px);

      a {
        .fms(14px);
        color: @c2;
         text-decoration-color: @c1;


      }
    }

  }

</style>
